// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemoLoginPage_container__LuKgU {
	margin-top: 10vh;
	border-radius: 2rem;
	padding: 3rem;
	background-color: rgb(253, 245, 234);
	display: flex;
	flex-direction: column;
}

.DemoLoginPage_container__LuKgU button {
	margin: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demoLogin/DemoLoginPage.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,oCAAoC;CACpC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,YAAY;AACb","sourcesContent":[".container {\r\n\tmargin-top: 10vh;\r\n\tborder-radius: 2rem;\r\n\tpadding: 3rem;\r\n\tbackground-color: rgb(253, 245, 234);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.container button {\r\n\tmargin: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DemoLoginPage_container__LuKgU`
};
export default ___CSS_LOADER_EXPORT___;
